<template>
	<div class="parts-locations-sms-email-card">
		<!-- Parts Invoice Section -->
		<SectionContainer>
			<template #left>
				<h4>Parts Invoice</h4>
			</template>
			<template #content>
				<ul>
					<li>Email Provider</li>
					<li>Reply-To Email</li>
					<li>Email Provider</li>
				</ul>
			</template>
		</SectionContainer>
		<!-- Parts Desk Section -->
		<SectionContainer>
			<template #left>
				<h4>Parts Desk</h4>
			</template>
			<template #content>
				<ul>
					<li>Email Provider</li>
					<li>Reply-To Email</li>
					<li>SMS Provider</li>
				</ul>
			</template>
		</SectionContainer>
		<!-- Special Order Parts Section -->
		<SectionContainer>
			<template #left>
				<h4>Special Order Parts</h4>
			</template>
			<template #content>
				<ul>
					<li>Email Provider</li>
					<li>Reply-To Email</li>
					<li>SMS Provider</li>
				</ul>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';

export default {
	name: 'PartsLocationsSmsEmailCard',
	components: { SectionContainer }
};
</script>

<style lang="scss" scoped>
.parts-locations-sms-email-card {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;

	&__item {
		display: block;
	}

	.section-header {
		display: inline-block;
	}
}
</style>
